import { CheckOutlined } from '@ant-design/icons'
import { Button } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type FixedFooterProps = {
  isUpdateLoading: boolean
  isDirty: boolean
  handleSubmit: () => {}
}

const FixedFooter = ({
  isUpdateLoading,
  isDirty,
  handleSubmit
}: FixedFooterProps) => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <Button
        isLoading={isUpdateLoading}
        variant="primary"
        type="submit"
        disabled={!isDirty}
        onClick={handleSubmit}
      >
        <CheckOutlined />
        {t('SAVE_CHANGES')}
      </Button>
    </Wrapper>
  )
}

export default FixedFooter

const Wrapper = styled.div.attrs({
  className: 'lmc-fixed-footer'
})`
  border: none;
  display: flex;
  justify-content: flex-end;
  width: calc(100vw - 290px);
  @media (max-width: 768px) {
    width: 100vw;
  }
`
